import React from "react"
import { StaticQuery, graphql } from "gatsby"
import "../fonts/sourcesanspro.css"
interface Props {
  description?: string,
  lang?: string,
  title: string,
  productTitle?: string
}

function SEO({ description, lang, title, productTitle }: Props) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        return (
          <>
            <html lang={lang} />
            <title>{productTitle ? `${title} | ${productTitle}` : title}</title>
            <meta name="description" content={metaDescription} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:creator" content={data.site.siteMetadata.author} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaDescription} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content="website" />
            <script async src="https://www.googletagmanager.com/gtag/js?id=UA-60681419-9" />
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
              
                gtag('config', 'UA-60681419-9');
              `}
            </script>
            <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/4053282.js" />
            <base target="_blank" />
          </>
        )
      }}
    />
  )
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
